<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M19.5303 6.84967C19.8232 7.14257 19.8232 7.61744 19.5303 7.91034L9.53033 17.9103C9.23744 18.2032 8.76256 18.2032 8.46967 17.9103L4.46967 13.9103C4.17678 13.6174 4.17678 13.1426 4.46967 12.8497C4.76256 12.5568 5.23744 12.5568 5.53033 12.8497L9 16.3193L18.4697 6.84967C18.7626 6.55678 19.2374 6.55678 19.5303 6.84967Z"
      fill="#000" />
  </svg>
</template>